import styled from "styled-components";
import { DropdownProps } from "./Dropdown.types";
import { getSizeInRem } from "../../methods/common";
import { clickableCursorStyle } from "../../mixins/cursor";
import { getCommonFontStyleMixin } from "../../mixins/font";
const BorderRadius = getSizeInRem(12);

export const DropdownWrapper = styled.div<Partial<DropdownProps>>`
    .dropdown-main {
        display: inline-block;
    }
    .dropdown__control {
        ${clickableCursorStyle};
        direction: ltr;
    }

    .dropdown__menu {
        display: inline-block;
        width: auto;

        .dropdown__menu-list {
            padding: ${BorderRadius};
            .dropdown__option {
                ${clickableCursorStyle}
                background-color: white;
                display: inline-flex;
                padding: ${getSizeInRem(14)} ${getSizeInRem(18)};
                border: 1px solid #e3e3e3;
                display: inline-flex;
                align-items: center;
                justify-content: flex-start;
                gap: 10px;
                min-width: max-content;

                ${getCommonFontStyleMixin({
                    weight: "medium",
                })}
                &:first-of-type {
                    border-radius: ${BorderRadius} ${BorderRadius} 0 0;
                }
                &:last-of-type {
                    border-radius: 0 0 ${BorderRadius} ${BorderRadius};
                }
            }
        }
    }
`;
